import { redirect } from 'react-router'
import { publicAction } from '@/data/loaders';

export function loadRubric({ request, params }) {
  return new Promise(function(resolve, reject) {

    if (params.rubric_id == "new") {
      return resolve({});
    }

    publicAction("getRubric", { id: params.rubric_id }, { educatorOnly: redirect("/courses") }).then(function({ data }) {
      if (data.value) {
        resolve({ data });
      } else {
        reject({text: "Rubric not found", path: "/rubrics", status: 404 });
      }
    }).catch(reject);

  })
}

export function loadRubrics() {
  return publicAction("getMyRubrics", {}, { educatorOnly: redirect("/courses") });
}

export function rubricSubmit({ request, params }) {
  return new Promise(function(resolve, reject) {
    request.json().then(function(data) {

      publicAction("createOrUpdateRubric", {
        ...data,
        id: params.rubric_id == "new" ? null : params.rubric_id
      }).then(function({ data }) {
        resolve(redirect("/rubrics"));
      }).catch(() => {
        resolve({success: false, date: Date.now()});
      });

    })
  })
}